const REACT_APP_CLIENT_ID = 'ce9c6e187b6d476a96027b70e12dd797'; export default REACT_APP_CLIENT_ID;
